<span
  *ngIf="!isLk"
  class="np-informer-trigger"
  (click)="onDialogStart()"
  pTooltip="Голосовой помощник"
  tooltipPosition="left"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
  <i class="pi pi-microphone cursor-pointer p-text-secondary"></i>
</span>

<p-dialog
  header="Говорите"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isOpened"
  (onHide)="onCancel()">
  <div class="text-center">
    <p-button
      styleClass="p-button-text border-circle"
      pTooltip="Кликните для подтверждения"
      tooltipPosition="left"
      tooltipStyleClass="p-n-tooltip"
      (onClick)="onSubmit()">
      <i
        class="pi pi-microphone text-8xl"
        [class.animation-fade-in-out]="isRecording"
        ></i>
    </p-button>
  </div>
</p-dialog>
